import { jsx as o, jsxs as N } from "react/jsx-runtime";
import { c as x } from "../../../index-2QXL0WYc.js";
import { useMemo as f } from "react";
import { propagateTestid as b } from "../../../helpers/utility/propagateTestid.js";
import { F as L } from "../../../FieldAppendToLabel-DgXoSKDG.js";
import { FieldLegend as g } from "../components/FieldLegend.js";
const y = "ids-field-group-v5150", A = "ids-field-group--invalid-v5150", E = "ids-field-group--hidden-label-v5150", k = "ids-field-group--legend-v5150", q = "ids-field-group--fields-v5150", w = "ids-field-group--inline-v5150", z = "ids-field-group--join-v5150", l = {
  fieldGroup: y,
  invalid: A,
  hiddenLabel: E,
  legend: k,
  fields: q,
  inline: w,
  join: z
}, O = ({
  children: c,
  className: m,
  "data-testid": n,
  error: d,
  errorMessages: i,
  hiddenLabel: t,
  hint: p,
  inline: u,
  join: v,
  label: a,
  optional: e,
  required: j,
  ...h
}) => {
  const F = f(
    () => !!d || (i == null ? void 0 : i.length),
    [d, i == null ? void 0 : i.length]
  ), G = f(
    () => !p && !d && !(i != null && i.length) ? null : /* @__PURE__ */ o(
      L,
      {
        hint: p,
        error: d,
        errorMessages: i,
        hiddenLabel: t,
        "data-parent-testid": n
      }
    ),
    [n, d, i, t, p]
  );
  return /* @__PURE__ */ N(
    "fieldset",
    {
      className: x(m, l.fieldGroup, {
        [l.inline]: u,
        [l.invalid]: F,
        [l.hiddenLabel]: t,
        [l.join]: v
      }),
      "data-testid": n,
      ...h,
      children: [
        /* @__PURE__ */ o(
          g,
          {
            append: G,
            className: l.legend,
            "data-testid": b(n, "legend"),
            hiddenLabel: t,
            optional: e,
            required: j,
            children: a
          }
        ),
        /* @__PURE__ */ o("div", { className: l.fields, children: c })
      ]
    }
  );
};
export {
  O as IressFieldGroup
};
